import { render, staticRenderFns } from "./PlusOutline.vue?vue&type=template&id=6a1815f2&"
import script from "./PlusOutline.vue?vue&type=script&lang=js&"
export * from "./PlusOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports